import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import {
  BundleApplianceDetailsBasket,
  SkyMobilePriceConfig,
} from '@sky/util-models';

import { devicesAdapter, DevicesState } from './devices.reducer';

import { filter } from 'lodash';
import { BasketState } from '../basket.reducer';
import { getBasketState } from '../basket.selectors';

const LT_APPLIANCE_CODE = 'C>';

const { selectAll: selectDevices, selectEntities: selectDevicesEntities } =
  devicesAdapter.getSelectors();

export const getDevicesState = createSelector(
  getBasketState,
  (state: BasketState) => state.devices
);

export const getDevicesLoaded = createSelector(
  getDevicesState,
  (state: DevicesState) => state.remoteState
);

export const getDevicesEntities = createSelector(
  getDevicesState,
  (state: DevicesState): Dictionary<BundleApplianceDetailsBasket> =>
    selectDevicesEntities(state)
);

export const getAllImeiInBasket = createSelector(
  getDevicesState,
  (state: DevicesState): string[] =>
    filter(state.entities, (entity) => entity?.imei !== undefined).map(
      (item) => item?.imei || ''
    )
);

export const getAllDevices = createSelector(
  getDevicesState,
  (state: DevicesState): BundleApplianceDetailsBasket[] => selectDevices(state)
);

export const isEmpty = createSelector(
  getAllDevices,
  (devices: BundleApplianceDetailsBasket[]): boolean => !devices.length
);

export const isSkyEssential = createSelector(
  getDevicesState,
  (state: DevicesState): boolean => state.isSkyEssential
);

export const getSkyMobilePriceConfig = createSelector(
  getDevicesState,
  (state: DevicesState): SkyMobilePriceConfig[] | undefined =>
    state.skyMobilePriceConfig
);

export const getSkyLinkedDevices = createSelector(
  getAllDevices,
  (devices: BundleApplianceDetailsBasket[]): BundleApplianceDetailsBasket[] =>
    devices.filter(
      // TODO: remove hardcoded QK values when API supports 'baseCategory' property
      (item: BundleApplianceDetailsBasket) =>
        item.applianceCode !== 'QK' && item.applianceCode !== 'QK_VIP'
    )
);

export const getNumberOfIncludedLtDevices = createSelector(
  getAllDevices,
  (devices: BundleApplianceDetailsBasket[]): number =>
    devices.filter((device) => device.applianceCode === LT_APPLIANCE_CODE)
      .length
);
